import { useMutation, useQuery } from '@apollo/client';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { useSelectedDetailQuery } from '../../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import { IBusinessCollectionProps } from '../../../../../../Types/ObjektVy';
import { handleGQLError } from '../../../../../../Utils/Error';
import BusinessDataForm, {
  BusinessDataFormContext,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import UpdateMutation from '../Mutations/UtanordningMutation.gql';
import AddMutation from '../Mutations/UtanordningAddMutation.gql';
import {
  UtanordningUpdateMutation,
  UtanordningUpdateMutationVariables,
} from '../Mutations/_QueryTypes/UtanordningUpdateMutation';
import {
  UtanordningAddMutation,
  UtanordningAddMutationVariables,
} from '../Mutations/_QueryTypes/UtanordningAddMutation';
import {
  UtanordningQuery,
  UtanordningQuery_node_TEDEKBokforder,
  UtanordningQueryVariables,
} from '../Queries/_QueryTypes/UtanordningQuery';
import query from '../Queries/UtanordningQuery.gql';
import EDAvenyProgress from '../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import BokforderContextManager from '../Components/BokforderContext/BokforderContextManager';
import bokforderSettingsQuery from '../Queries/BokforderSettingsQuery/BokforderSettingsQuery.gql';
import {
  BokforderSettingsQuery,
  BokforderSettingsQueryVariables,
} from '../Queries/BokforderSettingsQuery/_QueryTypes/BokforderSettingsQuery';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import ObjektVySida from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import { ObjektVyKort } from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import ObjektVy from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import { selectedId } from '../../../../../../Components/MasterDetail/MasterDetailUtils';
import { AssociationList } from '../../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import {
  bokforderMessageModel,
  bokforderModel,
  getBokforderDokConfig,
} from '../Utils/detaljvyUtils';
import { BokforderMessages } from '../Components/BokforderMessages/BokforderMessages';
import AddBokforderMessageButton from '../Components/AddBokforderMessageButton/AddBokforderMessageButton';
import {
  defaultEditMenuCancelButton,
  IEditMenuAction,
  IFormData,
  IValidateFn,
  removeIdsFromNewAssociations,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { IBokforderUtanordningDetaljVyCommonProps } from './BokforderDetaljvy';
import { useValidateUtanordning } from '../Hooks/useValidateUtanordning';
import KonteringContext from '../../../../_Common/Components/KonteringManager/KonteringContext';
import { useBokforderEditMenuSaveButton } from '../Hooks/useBokforderEditMenuSaveButton';
import BokforderSendBackDialog from '../Components/BokforderSendBackDialog/BokforderSendBackDialog';
import { useBokforderEditMenuAttestButton } from '../Hooks/useBokforderEditMenuAttestButton';
import { useBokforderEditMenuSendBackButton } from '../Hooks/useBokforderEditMenuSendBackButton';
import { useBokforderEditMenuRetakeButton } from '../Hooks/useBokforderEditMenuRetakeButton';
import { useBokforderEditMenuSendButton } from '../Hooks/useBokforderEditMenuSendButton';
import BokforderAreYouSureDialog from '../Components/BokforderAreYouSureDialog/BokforderAreYouSureDialog';
import { UtanordningBankkontoCard } from '../Components/UtanordningBankkonto/UtanordningBankkonto';
import { BokforderDetailInfoCard } from '../Components/BokforderDetailInfoCard/BokforderDetailInfoCard';
import useValidateKontering from '../Hooks/useValidateKontering';
import { getVariantDisplayText } from '../Utils/BfoUtanordningUtils';
import {
  TEDEKBokforderMinBokforderStatusEnum,
  TEDEKBokforderU_UTBETALNINGSKATEGORIEnum,
  TEDEKBokforderVariantEnum,
  TEDInputEKBokforderAddValues,
} from '../../../../../../globalQueryTypes';
import BokforderCreateDialog from '../Components/BokforderCreateDialog/BokforderCreateDialog';
import { utanordningFormStateActionTransformer } from '../Utils/UtanordningUtils';
import { UtanordningPGBGCard } from '../Components/UtanordningPGBG/UtanordningPGBG';
import useValidateUtanordningKontering from '../Hooks/useValidateUtanordningKontering';
import { UtanordningGridCard } from '../Components/UtanordningGrid/Components/UtanordningGridCard';
import { ISelectedDetail } from '../../../../../../Types/MasterDetailTypes';
import { BokforderType } from '../Queries/_QueryTypes/BokforderType';
import { UtanordningTillgodoCard } from '../Components/UtanordningTillgodo/UtanordningTillgodo';
import AdditionalAttestDialog from '../Components/AdditionalAttestDialog/AdditionalAttestDialog';
import BokforderContext from '../Components/BokforderContext/BokforderContext';
import { BokforderWrapperContext } from '../../../Rutiner/Bokforder/Contexts/BokforderWrapperContext';

interface IProps
  extends IBusinessCollectionProps,
    IBokforderUtanordningDetaljVyCommonProps {
  utbetalningsKategori: TEDEKBokforderU_UTBETALNINGSKATEGORIEnum | null;
}

export const UtanordningDetaljvy: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { activeDatabase, userID } = useContext(ActiveDatabaseContext);
  const konteringContext = useContext(KonteringContext);
  const bokforderWrapperContext = useContext(BokforderWrapperContext);
  const [removeRowsDialog, setRemoveRowsDialog] = useState(false);
  const [sendBackDialogOpen, setSendBackDialogOpen] = useState(false);
  const [onSendCallback, setOnSendCallback] = useState<{
    callback: (args?: any) => void;
  }>({ callback: () => {} });

  const validateUtanordning = useValidateUtanordning(props.id);
  const validateKontering = useValidateKontering();
  const validateUtanordingKontering = useValidateUtanordningKontering();

  const { loading, nodeData, refetch } = useSelectedDetailQuery<
    UtanordningQuery,
    UtanordningQuery_node_TEDEKBokforder,
    UtanordningQueryVariables
  >(query, props.id, { queryOptions: { onError: handleGQLError } });

  const bokforderSettingsQueryResult = useQuery<
    BokforderSettingsQuery,
    BokforderSettingsQueryVariables
  >(bokforderSettingsQuery, {
    variables: { dbName: activeDatabase ?? '' },
  });

  const [
    addMutation,
    { loading: addMutationLoading, error: addMutationError },
  ] = useMutation<UtanordningAddMutation, UtanordningAddMutationVariables>(
    AddMutation
  );

  const [updateMutation, { loading: mutationLoading, error }] = useMutation<
    UtanordningUpdateMutation,
    UtanordningUpdateMutationVariables
  >(UpdateMutation);

  const addFunction = useCallback(
    (values: IFormData) => {
      return addMutation({
        variables: {
          db: activeDatabase || '',
          values: values as TEDInputEKBokforderAddValues,
        },
      });
    },
    [addMutation, activeDatabase]
  );

  const updateFunction = useCallback(
    (values: IFormData) => {
      const newValues = removeIdsFromNewAssociations(values ?? {});
      return updateMutation({
        variables: {
          db: activeDatabase || '',
          values: {
            id: nodeData?.id ?? '',
            _version: nodeData?._version ?? 1,
            ...newValues,
          },
        },
      });
    },
    [updateMutation, activeDatabase, nodeData?.id, nodeData?._version]
  );

  const initialFormValue = useMemo(() => {
    let initValue = {};

    const selectedDetail = props.id as ISelectedDetail;
    if (selectedDetail?.data != null || props.isNew) {
      const selectedDetailData = selectedDetail?.data as BokforderType;

      //Sätt beställdatum till dagens datum för givna statusar
      if (
        selectedDetailData?.MinBokforderStatus ===
          TEDEKBokforderMinBokforderStatusEnum.UTKAST ||
        selectedDetailData?.MinBokforderStatus ===
          TEDEKBokforderMinBokforderStatusEnum.EJ_GODKAND_AV_ATTESTANT ||
        props.isNew
      ) {
        const today = new Date().toLocaleDateString('sv-SE');
        initValue = { ...initValue, BOKF_DATUM: today };
      }
    }

    if (props.variant) {
      const variantDisplayText = getVariantDisplayText(props.variant);
      initValue = { ...initValue, TEXT: `Utanordning ${variantDisplayText}` };
    }

    return initValue;
  }, [props.variant, props.id, props.isNew]);

  const BokforderDetailInfoCardVyer = useMemo(() => {
    switch (props.variant) {
      case TEDEKBokforderVariantEnum.UTANORDINGBANKONTO:
        return [BokforderDetailInfoCard, UtanordningBankkontoCard];
      case TEDEKBokforderVariantEnum.UTANORDINGKONTANT:
        return [BokforderDetailInfoCard];
      case TEDEKBokforderVariantEnum.UTANORDINGPGBG:
        return [BokforderDetailInfoCard, UtanordningPGBGCard];
      case TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO:
        return [BokforderDetailInfoCard, UtanordningTillgodoCard];

      default:
        return [BokforderDetailInfoCard];
    }
  }, [props.variant]);

  const messageVyer = useMemo(() => {
    return [BokforderMessages];
  }, []);

  const bokforderStatus = useMemo(() => {
    return nodeData?.STATUS;
  }, [nodeData]);

  const queriesLoading = useMemo(
    () =>
      loading ||
      mutationLoading ||
      addMutationLoading ||
      konteringContext.konteringValidationQueryLoading,
    [
      addMutationLoading,
      konteringContext.konteringValidationQueryLoading,
      loading,
      mutationLoading,
    ]
  );

  const editAttestButton: IEditMenuAction = useBokforderEditMenuAttestButton(
    queriesLoading,
    userID
  );

  const editSendBackButton: IEditMenuAction =
    useBokforderEditMenuSendBackButton(
      queriesLoading,
      userID,
      setSendBackDialogOpen
    );

  const editRetakeButton: IEditMenuAction = useBokforderEditMenuRetakeButton(
    queriesLoading,
    userID,
    props.setEditMessageID
  );

  const editSendButton = useBokforderEditMenuSendButton(
    bokforderSettingsQueryResult.data?.me?.[0]?.bokfgrupper?.[0]?.id,
    props.isNew,
    queriesLoading,
    userID,
    setRemoveRowsDialog,
    setOnSendCallback,
    props.utbetalningsKategori,
    props.type
  );

  const editSaveButton = useBokforderEditMenuSaveButton(
    bokforderSettingsQueryResult.data?.me?.[0]?.bokfgrupper?.[0]?.id,
    bokforderStatus,
    props.isNew,
    props.type,
    queriesLoading,
    userID,
    props.setEditMessageID,
    props.utbetalningsKategori
  );

  const editMenuCancelButton: IEditMenuAction = {
    ...defaultEditMenuCancelButton,
    label: () => (props.isNew ? 'Avbryt' : 'Ångra ändringar'),
    shortLabel: () => (props.isNew ? 'Avbryt' : 'Ångra'),
    onClick: ({ businessDataFormContext, editMenuOnCancel }) => {
      props.setEditMessageID('');
      if (props.isNew) {
        businessDataFormContext?.formStateDispatch({ type: 'CANCEL' });
      } else {
        businessDataFormContext?.formStateDispatch({ type: 'RESET' });
      }

      editMenuOnCancel?.();
    },
    isDisabled: ({ businessDataFormContext }) =>
      props.isNew
        ? businessDataFormContext.formState.loading ||
          businessDataFormContext.mutationLoading
        : businessDataFormContext.mutationLoading ||
          !businessDataFormContext.formState.formHasChanged,
  };

  return (
    <BusinessDataForm<UtanordningQuery_node_TEDEKBokforder>
      addMutation={addFunction}
      data={nodeData}
      dataLoading={
        loading ||
        konteringContext.konteringValidationQueryLoading ||
        bokforderWrapperContext.allBFOUsersLoading
      }
      editMenuActions={[
        editMenuCancelButton,
        editSaveButton,
        editSendButton,
        editRetakeButton,
        editSendBackButton,
        editAttestButton,
      ]}
      fullScreen={props.config?.fullPage ?? false}
      isNew={props.isNew}
      model={bokforderModel}
      mutationError={error ?? addMutationError}
      mutationLoading={mutationLoading || addMutationLoading}
      updateMutation={updateFunction}
      refetchData={refetch}
      formStateActionTransformer={utanordningFormStateActionTransformer}
      validateFns={[
        validateUtanordning as IValidateFn,
        validateKontering as IValidateFn,
        validateUtanordingKontering as IValidateFn,
      ]}
      initialValue={initialFormValue}
    >
      {loading && <EDAvenyProgress />}
      <BokforderContextManager
        settingsQueryResult={bokforderSettingsQueryResult}
        selectedDetail={props.id}
        editMessageID={props.editMessageID}
        setEditMessageID={props.setEditMessageID}
      >
        <ObjektVy
          nodeLoading={loading}
          editImplemented
          sideBySideWidths={[6, 6]}
        >
          <ObjektVySida
            caption="Bokföringsorder"
            collectionName={bokforderModel.CollectionName}
            sidNr={1}
          >
            <ObjektVyKolumner>
              <ObjektVyKolumn fullPage={false}>
                <ObjektVyKort
                  noPadding
                  bmod={bokforderModel}
                  caption="Detaljinfo"
                  id={props.id}
                  vyer={BokforderDetailInfoCardVyer}
                />
              </ObjektVyKolumn>

              <ObjektVyKolumn fullPage={false}>
                <UtanordningGridCard id={props.id} />
              </ObjektVyKolumn>

              <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
                <ObjektVyKort
                  bmod={bokforderMessageModel}
                  caption="Meddelanden"
                  id={props.id}
                  vyer={messageVyer}
                  button={() => <AddBokforderMessageButton />}
                />
              </ObjektVyKolumn>

              <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
                <ObjektVyKort caption="Dokument" readOnly>
                  <BokforderContext.Consumer>
                    {bokforderContext => (
                      <BusinessDataFormContext.Consumer>
                        {formContext => (
                          <AssociationList
                            associationName={'Dokument'}
                            associationPath={'Dokument'}
                            collectionName={'EKBokforder'}
                            config={getBokforderDokConfig(
                              formContext,
                              userID,
                              bokforderContext.isReservForAttestant,
                              bokforderContext.isReservForKontrollattestant
                            )}
                            ownId={selectedId(props.id)}
                          />
                        )}
                      </BusinessDataFormContext.Consumer>
                    )}
                  </BokforderContext.Consumer>
                </ObjektVyKort>
              </ObjektVyKolumn>
            </ObjektVyKolumner>
            <BokforderAreYouSureDialog
              boldWarningText="Ofullständiga rader tas bort från utanordningen. "
              open={removeRowsDialog}
              setOpen={setRemoveRowsDialog}
              title="Skicka vidare?"
              warningText="Vill du skicka utanordningen vidare för attest?"
              yesCallback={() => {
                onSendCallback.callback?.();
              }}
            />
            <BokforderSendBackDialog
              open={sendBackDialogOpen}
              setOpen={setSendBackDialogOpen}
              type={props.type}
            />
            <BokforderCreateDialog
              bokfgruppId={
                bokforderSettingsQueryResult.data?.me?.[0]?.bokfgrupper?.[0]?.id
              }
            />
            <AdditionalAttestDialog type={props.type} />
          </ObjektVySida>
        </ObjektVy>
      </BokforderContextManager>
    </BusinessDataForm>
  );
};
